var _defs, _circle, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _line2, _line3, _line4, _rect8, _circle2, _path3, _path4, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailerInsightsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-5 h-5",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "storeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E32934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6B75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "awningGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6B75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E32934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buildingGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0055A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#003D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "windowGlow",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "storeShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodOpacity: 0.3
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#storeGradient)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 36,
    height: 30,
    rx: 2,
    fill: "url(#buildingGradient)",
    filter: "url(#storeShadow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 24 L 14 20 L 50 20 L 52 24 Z",
    fill: "url(#awningGradient)",
    filter: "url(#storeShadow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 14 20 Q 32 26 50 20",
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 3,
    height: 4,
    fill: "white",
    opacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 3,
    height: 4,
    fill: "white",
    opacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    width: 3,
    height: 4,
    fill: "white",
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 20,
    width: 3,
    height: 4,
    fill: "white",
    opacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 8,
    height: 10,
    rx: 1,
    fill: "url(#windowGlow)",
    opacity: 0.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 8,
    height: 10,
    rx: 1,
    fill: "url(#windowGlow)",
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 28,
    x2: 24,
    y2: 38,
    stroke: "#0055A5",
    strokeWidth: 1,
    opacity: 0.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 33,
    x2: 28,
    y2: 33,
    stroke: "#0055A5",
    strokeWidth: 1,
    opacity: 0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 28,
    x2: 40,
    y2: 38,
    stroke: "#0055A5",
    strokeWidth: 1,
    opacity: 0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 33,
    x2: 44,
    y2: 33,
    stroke: "#0055A5",
    strokeWidth: 1,
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 8,
    height: 14,
    rx: 1,
    fill: "url(#storeGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 47,
    r: 1,
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 44 L 30 50 L 34 50 L 34 44",
    stroke: "white",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 44 Q 32 42 34 44",
    stroke: "white",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 16,
    r: 1.5,
    fill: "#FFD700",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 16,
    r: 1.5,
    fill: "#FFD700",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    fill: "#FFD700",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 12,
    r: 1,
    fill: "#FFD700",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailerInsightsIcon);
export default __webpack_public_path__ + "static/media/retailer-insights-icon.88d773cd5d065d285723fd8a5d5834eb.svg";
export { ForwardRef as ReactComponent };